
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AfterViewInit, Component, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { filter, Subject } from 'rxjs';
import { routeAnimations } from 'app/core/animations/route.animations';

@Component({
    selector: 'customer-layout',
    templateUrl: './customer.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [FuseLoadingBarComponent, RouterOutlet, RouterModule, MatSidenavModule,],
    animations: [routeAnimations],
})
export class CustomerLayoutComponent implements OnDestroy, AfterViewInit {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    @ViewChild('accountDrawer') accountDrawer!: MatDrawer;
    drawerMode: 'side' | 'over' = 'over';
    isSmallScreen = false;
    drawerWidth = '50vw';

    constructor(private breakpointObserver: BreakpointObserver, private router: Router, private route: ActivatedRoute) {
        this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall]).subscribe(result => {
            if (result.matches) {
                this.drawerWidth = '100%';
            } else {
                this.drawerWidth = '45vw';
            }
        });
    }

    ngAfterViewInit(): void {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.checkDrawerOutlet();
            });

        setTimeout(() => {
            this.checkDrawerOutlet();
        });
    }

    closeDrawer() {
        this.router.navigate([{ outlets: { drawer: null } }]);
    }

    private checkDrawerOutlet(): void {
        const root = this.router.routerState.snapshot.root;
        if (this.hasDrawerOutlet(root)) {
            this.accountDrawer.open();
        } else {
            this.accountDrawer.close();
        }
    }

    private hasDrawerOutlet(route: ActivatedRouteSnapshot): boolean {
        if (route.outlet === 'drawer') {
            return true;
        }

        for (const child of route.children) {
            if (this.hasDrawerOutlet(child)) {
                return true;
            }
        }

        return false;
    }

    prepareRoute(outlet: RouterOutlet) {
        return outlet?.activatedRouteData?.['animation'];
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
